import React from "react";
// import { BackIcon, CloseIcon } from "../../../components/Icons";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { useBookingAppointmentTypeStore, useBookingReasonsNavigation } from "../../../hooks";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { CREATE_BOOKING_TYPE } from "../../../config/params";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";

interface IConfirmDoctorVisitToggleContainer{
  setActiveStep: (step: number) => void;
  handleMixPanelLog: (event: string, referredFromPage?: string) => void;

}

const ConfirmDropoffToggleContainer = (
  {
    setActiveStep,
    handleMixPanelLog,
  }: IConfirmDoctorVisitToggleContainer) => {
  const { setBookingAppointmentType } = useBookingAppointmentTypeStore();
  const { setAppointmentsForm, setReasonForVisit, setPromoCodeData } = useAppointmentStore();
  const { setDefaultSelectionValues }=useBookingReasonsNavigation();

  const handleContinueDoctorVisitCta = () => {
    setActiveStep(2);
    handleMixPanelLog(MIXPANEL_EVENTS.USER_SWITCH_TO_IN_ROOM_VISIT, "pop_up");
  };

  const handleConfirmDropOff = () => {
    setAppointmentsForm(null);
    setDefaultSelectionValues();
    setPromoCodeData([]);
    setReasonForVisit({});
    handleMixPanelLog(MIXPANEL_EVENTS.USER_CONFIRM_DROP_OFF_APPOINTMENT);
    setBookingAppointmentType(CREATE_BOOKING_TYPE.DROPOFF_BOOKING);
    setActiveStep(1);
  };

  return (
    <div className="flex flex-col justify-between h-full">
      <div className="flex items-center h-full">
        <div className="">
          <div>
            <img
              className="max-h-60 max-w-60 mx-auto"
              alt="Droppoff_card_logo_icon"
              src="/assets/icons/Droppoff_card_logo.png"
            />
          </div>
          <div className="text-2xl font-bold text-center mt-2">
          Book a Drop-Off Visit?
          </div>
          <p className="text-light-black text-center mt-1.5 2xl:px-8">
          Switching to a Drop-Off will cancel your Doctor visit.
          You’ll have to choose a new time based on availability. What would you like to do?
          </p>
        </div>
      </div>
      <div className="space-y-3 text-center">
        <StyledBookingFlowButton
          color="primary"
          size="small"
          className="w-full"
          onClick={handleConfirmDropOff}
        >
          Book a Drop-Off Visit
        </StyledBookingFlowButton>
        <StyledBookingFlowButton
          onClick={handleContinueDoctorVisitCta}
          color="primary"
          size="small"
          className="!bg-transparent !border !border-gray-4 !text-black w-full hover:!bg-gray-3 !my-4"
        >
          Continue Booking a Doctor Visit
        </StyledBookingFlowButton>
      </div>
    </div>
  );
};

export default ConfirmDropoffToggleContainer;
